<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler">
            <el-form-item label="交易中心">
                {{model.jyzxname}}
            </el-form-item>
            <el-form-item label="项目名称">
                {{form.zbproname}}
            </el-form-item>
            <el-form-item
                class="table-full-row"
                label="是否属于依法招标">
                <span v-if="model.izyfzb==='0'">否</span>
                <span v-if="model.izyfzb!='0'">是</span>
            </el-form-item>
            <template v-if="form.ext4=='130500'">
                <el-form-item
                    class="table-full-row"
                    label="监督部门">
                    {{extModel.supervisiondepartment}}
                </el-form-item>
            </template>
            <el-form-item v-if="form.customcode" label="关联项目编号" class="table-full-row">
                {{form.customcode}}
            </el-form-item>
            <el-form-item label="代理机构项目负责人">
                {{form.prousername}}
            </el-form-item>
            <el-form-item label="项目负责人手机号码">
                {{form.e_lxrphone2}}
            </el-form-item>
            <el-form-item label="招标人统一社会信用代码">
                {{form.xmzbrcode}}
            </el-form-item>
            <el-form-item label="招标人名称">
                {{form.xmzbrname}}
            </el-form-item>

            <template v-if="form.ext4=='130700'">
                <el-form-item 
                label="采购计划名称">
                    {{form.planname}}
                </el-form-item>

                <el-form-item 
                label="一级预算部门">
                    {{form.budgetdepartment}}
                </el-form-item>

                <el-form-item 
                label="采购办办案结束时间">
                    {{form.shrdate}}
                </el-form-item>

                <el-form-item 
                label="采购计划填写时间">
                    {{form.operatedate}}
                </el-form-item>

                <el-form-item 
                label="审批情况">
                    {{form.shenpitypename}}
                </el-form-item>
                    
                <el-form-item 
                label="是否通过书面推荐方式选择供应商">
                    <span v-if="form.istuijian=='1'">是</span>
                    <span v-if="form.istuijian=='0'">否</span>
                </el-form-item>
            </template>

            <el-form-item label="招标人联系人">
                {{form.e_xmfzr}}
            </el-form-item>
            <el-form-item label="联系人手机号码">
                {{form.e_fzrphone}}
            </el-form-item>
            <el-form-item label="项目所属行业" class="table-full-row">
                {{pModel.prohyflname}}
            </el-form-item>
            <el-form-item label="投资主体性质">
                <span v-if="extModel.investtype==='10'">政府投资</span>
                <span v-if="extModel.investtype==='20'">企业投资</span>
                <span v-if="extModel.investtype==='30'">其他</span>
            </el-form-item>
            <el-form-item label="项目预算">
                {{pModel.e_zbgse}}万元
            </el-form-item>
            <el-form-item label="行业分类">
                {{extModel.industrycategory}}
            </el-form-item>
            <el-form-item label="交易组织形式">
                <span v-if="extModel.tranmode==='50'">集中代理机构组织</span>
                <span v-if="extModel.tranmode==='51'">社会代理机构组织</span>
                <span v-if="extModel.tranmode==='53'">其他组织机构</span>
            </el-form-item>

            <el-form-item label="PPP项目">
                <span v-if="extModel.ispppproject==='10'">是</span>
                <span v-if="extModel.ispppproject==='20'">否</span>
            </el-form-item>
            <el-form-item label="是否需要投标人报名" v-if="sfyxbm == '1'">
                <span v-if="form.extsfbm==='0'">否</span>
                <span v-if="form.extsfbm==='1'">是</span>
            </el-form-item>
            <el-form-item label="投标保证金" v-if="form.sftbbzj==='0'" class="table-full-row">
                <span>否</span>
            </el-form-item>
            <el-form-item label="投标担保形式" v-if="form.sftbbzj!=='0'">
                <span v-if="form.extbzjtype==='0'">只保证金</span>
                <span v-if="form.extbzjtype==='1'">只保函</span>
                <span v-if="form.extbzjtype==='2'">保证金或保函</span>
                <span v-if="form.extbzjtype==='9'">其他</span>
                <el-button
                icon="el-icon-edit" 
                size="mini" 
                @click="dialogVisible=true"
                type="primary">
                    修改投标担保形式
                </el-button>
            </el-form-item>
            <el-form-item label="保证金缴纳账户" v-if="form.sftbbzj!=='0'" class="table-full-row">
                <span v-if="form.by1==='0'">{{`${ptPlaceholder}平台虚拟账号`}}</span>
                <span v-if="form.by1==='3'">交易中心保证金账号</span>
                <span v-if="form.by1==='1'">其他</span>
                <span v-if="form.extbzjtype==='1'">只保函形式下无保证金账号</span>
            </el-form-item>
            <el-form-item v-if="form.ext3 === '2' && form.ext3childtype === '1'" label="采购方式">
                <span v-if="form.cgtype==='1'">封闭式</span>
                <span v-if="form.cgtype!=='1'">开放式</span>
            </el-form-item>
            <el-form-item v-if="form.ext3 === '2' && form.ext3childtype === '1'" label="制作/上传招标文件是否使用CA锁">
                <span v-if="form.nocakey==='1'">不使用</span>
                <span v-if="form.nocakey!=='1'">使用</span>
            </el-form-item>
            <el-form-item v-if="!(form.ext3 === '2' && form.ext3childtype === '1')" label="制作/上传招标文件是否使用CA锁" class="table-full-row">
                <span v-if="form.nocakey==='1'">不使用</span>
                <span v-if="form.nocakey!=='1'">使用</span>
            </el-form-item>
            <el-form-item label="谈判文件获取方式" v-if="model.type==='3'" class="table-full-row">
                <span v-if="form.zbfscode==='1'">发布公告公开下载文件方式</span>
                <span v-if="form.zbfscode==='2'">邀请指定供应商方式</span>
            </el-form-item>
            <el-form-item label="磋商文件获取方式" v-if="model.type === '6'" class="table-full-row">
                <span v-if="form.zbfscode==='1'">发布公告公开下载文件方式</span>
                <span v-if="form.zbfscode==='2'">邀请指定供应商方式</span>
            </el-form-item>

            <el-form-item label="是否电子开标评标">
                <span v-if="form.extzbgj==='1'">是</span>
                <span v-if="form.extzbgj==='0'">否</span>
            </el-form-item>
            <el-form-item label="招标组织形式">
                <span v-if="form.zbzzxscode==='1'">自行招标</span>
                <span v-if="form.zbzzxscode==='2'">委托招标</span>
                <span v-if="form.zbzzxscode==='9'">其他</span>
            </el-form-item>

            <el-form-item label="附件" class="table-full-row">
                <my-upload readonly :file-guid="form.fjglbs"></my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button v-if="isRevision!=1" icon="el-icon-circle-close" @click="scope.cancleHandler">关闭</el-button>
                <span v-if="isRevision==1"></span>
            </template>
        </my-form>

        <el-dialog
            title="修改投标担保形式"
            :visible.sync="dialogVisible"
            width="30%">
            <div>
                <my-radio
                    v-model="extbzjtype"
                    :data="[{key:'0', value:'只保证金'}, {key:'1', value:'只保函'}, {key:'2', value:'保证金或保函'}, {key:'9', value:'其他'}]">
                </my-radio>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeExtbzjtype">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'


export default {
    mixins: [ FORM_PAGE_MIXIN],

    data: () => ({
        form: {},
        model:{},
        pModel:{},
        extModel:{},
        dialogVisible:false,
        extbzjtype:'0',
        ptPlaceholder: window._config.title2,
        isRevision:'',
        sfyxbm:"",
    }),
    methods: {
        // 初始化
        detailInit(){
            var that = this
            that.jspInit(`${that.getGetters('mngUrl')}/revision/Zbdl/GovPurchase/detail.json`,{
                type:that.getQuery('type'),
                id:that.getQuery('id'),
                childtype:that.getQuery('childtype'),
            }, data => {
                that.model = data
                that.pModel = data.pModel
                that.extModel = data.extModel
                that.form = data.model
                that.extbzjtype = that.form.extbzjtype;
                if(that.getQuery('ext3childtype') == '1'){
                    that.sfyxbm = '1';
                }else{
                    that.getTbrbmFlag(that.form.ext5);
                }
            });
        },
        // 修改担保形式
        changeExtbzjtype(){
            this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/ZbProject/changeExtbzjtype.json`,{
                extbzjtype:this.extbzjtype,
                zbprocode:this.form.zbprocode
            }, (data, res) => {
                ShowMsg('修改投标担保形式成功','success')
                this.dialogVisible = false
                this.detailInit()
            });
        },
        //获取是否显示投标人报名
        getTbrbmFlag(n){
            this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/GovPurchase/getsfyxbm.json`,{
                jyzxcode:n
            }, (data, res) => {
                this.sfyxbm = data;
            });
        },
    },
    created() {
        this.detailInit()
        
    },
    mounted() {
        this.isRevision = getSession('isRevision')
    },
}
</script>

<style scoped lang="scss">

</style>

 